import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cloud-migration-tool-landing-page',
  templateUrl: './cloud-migration-tool-landing-page.component.html',
  styleUrls: ['./cloud-migration-tool-landing-page.component.scss']
})
export class CloudMigrationToolLandingPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
